import Swal from "sweetalert2";

// Receipt / Ranu theme colours
const MAROON = "#7A1410";
const GOLD = "#C89B3C";

// Gold background on hover for the main (Yes / Send) button.
// SweetAlert2 sets the button colour inline, so the hover is done with listeners.
const goldOnHover = (button, baseColor) => {
  if (!button) return;
  button.addEventListener("mouseenter", () => {
    button.style.backgroundImage = "none";
    button.style.backgroundColor = GOLD;
  });
  button.addEventListener("mouseleave", () => {
    button.style.backgroundColor = baseColor;
  });
};

// Spread this into any Swal.fire({...}) to get the theme (used here and in FormUtil.confirmAction)
export const themedDialog = {
  iconColor: GOLD,
  confirmButtonColor: MAROON,
  cancelButtonColor: GOLD,
  didOpen: () => {
    const popup = Swal.getPopup();
    if (popup) popup.style.fontFamily = '"Poppins", "Helvetica", "Arial", sans-serif';
    const titleEl = Swal.getTitle();
    if (titleEl) titleEl.style.color = MAROON;
    const cancelBtn = Swal.getCancelButton();
    if (cancelBtn) cancelBtn.style.color = "#fff";
    goldOnHover(Swal.getConfirmButton(), MAROON);
  },
};

export const deleteMsg = (item) => ({
  title: `Delete ${item}?`,
  text: `This ${item} will be deleted.`,
  confirmButtonText: "Yes, delete",
});

export const saveMsg = (item) => ({
  title: "Save changes?",
  text: `Do you want to save the changes you made to this ${item}?`,
  icon: "question",
  confirmButtonText: "Yes, save",
});

// popUp(Function, args, options?) : options = { title, text, icon, confirmButtonText }
// Without options the old default message is shown.
export const popUp = async (Function, args, options = {}) => {
  const {
    title = "Are you sure?",
    text = "You won't be able to revert this!",
    icon = "warning",
    confirmButtonText = "Yes",
  } = options;

  const result = await Swal.fire({
    title,
    text,
    icon,
    width: "40vh",
    showCancelButton: true,
    confirmButtonText,
    ...themedDialog,
  });

  if (result.isConfirmed) {
    await Function(args);
  }
};
